module.exports = __webpack_public_path__ + "img/adq.5faff49e.svg";